module.exports = __webpack_public_path__ + "img/img-ac77d7d3.17ccfa3b.png";